/**
 * @deprecated Import from office-ui-fabric-react package instead.
 */
export { Text } from 'office-ui-fabric-react/lib/Text';
